import React from 'react';
import classNames from 'classnames';
import { AlignCenter, AlignEnd, AlignStart } from '@styled-icons/bootstrap';
import { InterpreterFrom } from 'xstate';
import { useActor } from '@xstate/react';
import styles from '../Navbar.module.css';
import { NavbarContainerOptionsMachineType } from '../../../nodes/navbar/fsm/NavbarContainer.fsm';
import { NAVBAR_ALIGNMENT } from '../../../constants';

function NavbarAlignOptions(props: {
  machine: InterpreterFrom<NavbarContainerOptionsMachineType>;
}) {
  const { machine } = props;
  const [machineState, machineSend] = useActor(machine);
  const content = machineState.context?.dataNavbar;

  return (
    <div className={styles.navbarOptions}>
      <div className={styles.navbarOptionsTitle}>Align</div>
      <div
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.alignment === NAVBAR_ALIGNMENT.START,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.ALIGNMENT.CHANGE',
            payload: { newAlign: NAVBAR_ALIGNMENT.START },
          })
        }
        role="none"
      >
        <AlignStart size={18} />
      </div>
      <div
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.alignment === NAVBAR_ALIGNMENT.CENTER,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.ALIGNMENT.CHANGE',
            payload: { newAlign: NAVBAR_ALIGNMENT.CENTER },
          })
        }
        role="none"
      >
        <AlignCenter size={18} />
      </div>
      <div
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.alignment === NAVBAR_ALIGNMENT.END,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.ALIGNMENT.CHANGE',
            payload: { newAlign: NAVBAR_ALIGNMENT.END },
          })
        }
        role="none"
      >
        <AlignEnd size={18} />
      </div>
    </div>
  );
}

export default NavbarAlignOptions;
